$(document).ready(function(){
  // ====================================  topbar slider ============================== //
  
  
  // ====================================  hero banner slider ============================== //
  
$('.hero-post').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    fade:true,
    prevArrow: '.prev-i',
    nextArrow: '.next-i',
});
  
 $('.hero-content-list').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    fade:true,
    prevArrow: '.prev-btn',
    nextArrow: '.next-btn',
  });

  // ====================================  Blog slider ============================== //
  $(".blog__posts").slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
        dots:false,
		infinite: true,
		autoplay: false,
        prevArrow: '.prev-post',
        nextArrow: '.next-post',
        responsive: [
        {
           breakpoint:768,
           settings: {
              slidesToShow: 1,
              infinite: true,
         }
        }
    ] 
  });


  // ==================================== Faq Section ============================== //
  $('.faq-slider').slick({
    slidesToShow: 5,
    arrows:true,
    prevArrow: '.prev-faq',
    nextArrow: '.next-faq',
    responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 751,
      settings: {
        slidesToShow: 2,
      }
    },
   ]
  });

  $('.faq-box').on('click', function() {
    var dataIndex = $(this).data('index');
    $('.faq-des-box[data-index="' + dataIndex + '"]').fadeIn();
  });

  $('.close-popup').click(function () {
    $(this).closest('.faq-des-box').fadeOut();
  });
  
  $(".faq-box").click(function() {
        $("body").addClass("faq-popup-open");
  });
  $(".close-popup").click(function() {
        $("body").removeClass("faq-popup-open");
  });

  // ==================================== Testimonail Slider ================================//
  $(".c-reviws-slider").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		autoplay: false,
        prevArrow: '.prev-arrow',
        nextArrow: '.next-arrow',
        responsive: [
        {
            breakpoint: 991,
             settings: {
                    slidesToShow: 3,
                }
        },
        {
          breakpoint: 751,
          settings: {
            slidesToShow: 2,
          }
        },
        {
            breakpoint: 501,
             settings: {
                    slidesToShow: 1,
                    
                }
        }  
       ]
	});


  
  // ==================================== Ingredients Section ============================== //
  $('.ingredients-slider').slick({
    slidesToShow:3,
    arrows:true,
    prevArrow: '.prev-i',
    nextArrow: '.next-i',
    responsive: [
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 501,
      settings: {
        slidesToShow: 1,
      }
    },
  ],
  });
	$(".prev-i").click(function () {
		$(".slick-list").slick("slickPrev");
	});
  
  //$('.ingredient-footer a').on('click', function() {
   // var dataIndex = $(this).data('index');
   // $('.ingredient-des-box[data-index="' + dataIndex + '"]').fadeIn();
  //});

  //$('.close-popup').click(function () {
    //$(this).closest('.ingredient-des-box').fadeOut();
  //});
  
  //$(".ingredient-box").click(function() {
        //$("body").addClass("ingredient-popup-open");
  //});
  //$(".close-popup").click(function() {
       // $("body").removeClass("ingredient-popup-open");
  //});


  
});


// ==================================== Hero Product Section ============================== //
 
// accordian
document.querySelectorAll('.accordion-item').forEach((accordion) => {
  accordion.addEventListener('toggle', function() {
    if (this.open) {
      document.querySelectorAll('.accordion-item').forEach((otherAccordion) => {
        if (otherAccordion !== this) otherAccordion.removeAttribute('open');
      });
    }
  });
});  

$(document).ready(function(){
  $('.ptt-list').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    prevArrow: '.prev',
    nextArrow: '.next',
  });
  
  });  

$('.prev').click(function(){
  $('.ptt-list').slick('slickPrev');
})

$('.next').click(function(){
  $('.ptt-list').slick('slickNext');
})

$(document).ready(function () {
  $(".tab-button").click(function (e) {
    $(".ptt-list").slick("refresh");
  });
});



$(document).ready(function () {
	$(".product__image-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
    initialSlide: 1, // start on the second slide
		arrows: true,
        dots:true,
		infinite: true,
		autoplay: false,
        prevArrow: '.prev-i',
        nextArrow: '.next-i',
	});
});

$(document).ready(function () {
	$(".workslider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
        dots:false,
		infinite: true,
		autoplay: false,
        prevArrow: '.prev',
        nextArrow: '.next',
        responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 751,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
	});
});

// ==================================== Footer Block Section ============================== //
$('.footer-block__heading').click(function(e) {
  $(this).toggleClass('accordtion-title');
  $(this).parent('.footer-block--menu').toggleClass('foot-accordion-content');
});
// ==================================== Footer Block End ============================== //





// ============================= contact faq start
$('.acc-toggle').click(function(e) {
  $(this).toggleClass('active');
  $('.acc-toggle').not(this).removeClass('active');
  	e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
        //$(".acc-toggle h6").removeClass("active");
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
        //$(".acc-toggle h6").addClass("active");
    }
});

// ====================== ingredients tab
function openTab1(tabId1) {
  
  var selectedTab = document.getElementById(tabId1);
  if (selectedTab) {
      selectedTab.classList.add("active");
  }
  var clickedButton = document.querySelector('[onclick="openTab1(\'' + tabId1 + '\')"]');
  if (clickedButton) {
      clickedButton.classList.add("active-button");
  }
  // Hide all tab content
  var tabContents = document.querySelectorAll(".science-tab-box");
  tabContents.forEach(function (content) {
      content.classList.remove("active");
  });

  // Deactivate all tab buttons
  var tabButtons = document.querySelectorAll(".science-tab-item");
  tabButtons.forEach(function (button) {
      button.classList.remove("active-button");
  });

}

// trending post

function mobileOnlySlider() {
  $('.trending--post-slider').slick({
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '.prev4',
    nextArrow: '.next4',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }  
    },   
    {
      breakpoint: 525,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
});
}
if(window.innerWidth < 768) {
  mobileOnlySlider();
}

$(window).resize(function(e){
    if(window.innerWidth < 991) {
        if(!$('.trending--post-slider').hasClass('slick-initialized')){
            mobileOnlySlider();
        }
    }else{
        if($('.trending--post-slider').hasClass('slick-initialized')){
            $('.trending--post-slider').slick('unslick');
        }
    }
});



mobileOnlySliders(".announcementbar--content", false, true, 767);

function mobileOnlySliders($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots:false,
    arrows: true,
    prevArrow: '.prev-i',
    nextArrow: '.next-i',
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}





mobileOnlySlidersIngredient(".ingredients-grid", false, true, 767);

function mobileOnlySlidersIngredient($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
   	dots: $dots,
		arrows: $arrows,
    prevArrow: '.prev-i',
    nextArrow: '.next-i',
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}


$(document).ready(function() {
  $('#select-box').change(function() {
    var selectedValue = $(this).val();
    if(selectedValue == 1){
      $('#tab-01').removeClass('hide-tabs');
      $('#tab-02').addClass('hide-tabs');
      $('#tab-03').addClass('hide-tabs');
    }else if(selectedValue == 2){
      $('#tab-01').addClass('hide-tabs');
      $('#tab-02').removeClass('hide-tabs');
      $('#tab-03').addClass('hide-tabs');
    }else if(selectedValue == 3){
      $('#tab-01').addClass('hide-tabs');
      $('#tab-02').addClass('hide-tabs');
      $('#tab-03').removeClass('hide-tabs');
    }
  });
});